import React, { useEffect, useState } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import { getApi } from "../../api/endpoints.js";
import { toast } from "react-toastify";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet'
import { ZoomControl } from "react-leaflet";

const Map = () => {
  const [centerPostion] = useState([20.5937, 78.9629]);
  const [chargingZoneLocations] = getApi('chargingZoneLocations');
  const [locationsData, setLocationsData] = useState([]);

  useEffect(() => {
    getChargingZoneLocations();
  }, []);

  const getChargingZoneLocations = async (params) => {
    try{
      let response = await chargingZoneLocations({}).unwrap();
      setLocationsData(response.data.charging_zones.filter((location) => location.latitude && location.longitude ));
    } catch(error){
      toast.error('Something Went Wrong');
    }
  }

  const customIcon = new L.Icon({
    iconUrl: require('../../../assets/images/marker.png'),
    iconSize: [42, 42],
    iconAnchor: [16, 32],
  });

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ChargingZonesMapPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Charging Zones Map" }]}
    className={'charging-zones-map-page'}
  >
    <PageContentWrapper contentHeading={"Charging Zones Map"}>
      <div className="row d-flex m-4">
        <div className="card mb-3">
          <MapContainer
            center={centerPostion}
            zoom={5}
            scrollWheelZoom={false}
            attributionControl={false}
            zoomControl={false}
            style={{ height: '100vh', width: '100%'}}
          >
            <ZoomControl position="topright" />
            <TileLayer
              url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=MQyOxh16CEWpsAQcdplj"
              attribution='&copy; 2024 VoltUp.in'
              errorTileUrl="The map is failed to load."
              detectRetina={true}
            />
            {locationsData.length !== 0 && locationsData.map((location, index) => {
             return <Marker key={index} position={[location.latitude, location.longitude]} icon={customIcon}>
                <Popup>{location.name}</Popup>
              </Marker>
            })}
          </MapContainer>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Map;
